<div
  id="container"
  [style.background-image]="sanitizeImageUrl('url(' + image?.url + ')')"
  fxLayout="row"
  fxFlexAlign="center center"
  [ngClass]="{ bordered: !image, dragging: dragging }"
>
  <button mat-icon-button id="image-bt-upload" *ngIf="!loading && !disabled">
    <mat-icon *ngIf="dragging">check</mat-icon>
    <mat-icon *ngIf="!dragging">cloud_upload</mat-icon>
  </button>

  <button
    mat-icon-button
    id="image-bt-url"
    *ngIf="!loading && !dragging && !disabled"
    (click)="importFromUrl()"
  >
    <mat-icon>link</mat-icon>
  </button>

  <mat-spinner *ngIf="loading"></mat-spinner>

  <input
    *ngIf="!disabled"
    hidden
    type="file"
    #fileInput
    accept="image/*"
    (change)="uploadImage($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
  />
  <div id="label">{{ label }}</div>
</div>

<button
  mat-icon-button
  id="delete-bt"
  *ngIf="image && !loading && !dragging && !disabled"
  (click)="deleteImage($event)"
>
  <mat-icon>cancel</mat-icon>
</button>
